var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.05083 9.16699H0.143603V3.03516H2.05083V9.16699ZM1.08696 2.21484C0.492236 2.21484 4.86374e-05 1.70215 4.86374e-05 1.08691C4.86374e-05 0.492188 0.492236 0 1.08696 0C1.7022 0 2.19438 0.492188 2.19438 1.08691C2.19438 1.70215 1.7022 2.21484 1.08696 2.21484ZM9.16704 9.16699H7.28032V6.19336C7.28032 5.47559 7.25981 4.57324 6.27544 4.57324C5.29106 4.57324 5.14751 5.33203 5.14751 6.13184V9.16699H3.24028V3.03516H5.06548V3.87598H5.08599C5.35259 3.4043 5.96782 2.8916 6.89067 2.8916C8.81841 2.8916 9.18755 4.16309 9.18755 5.80371V9.16699H9.16704Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.73c44f4142fc13b17e4d7812bde68bd1.svg";
export { ForwardRef as ReactComponent };